<template>
    <div class="container">
        asdasddsa
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'notifications',
        created() {
            this.getContextNotifications().then(data => {
              console.log(data);
            });
        },
        methods: {
            ...mapActions([
                'getContextNotifications'
            ])
        }
    }
</script>
